<template>
</template>

<script>
	export default {
		mounted() {
			// localStorage.jwy = 1
			let ticket = this.$route.query.ticket
			this.$http.get(`/api/cas/hello?ticket=${ticket}`).then(res => {
				this.$http.get("/api/cas/hello").then(res=>{
					this.$message.success("欢迎登录人才大厦平台")
					sessionStorage.token = res.data.data.token
					sessionStorage.createId = res.data.data.loginUser.user.id
					sessionStorage.roleId = res.data.data.loginUser.user.roleId
					sessionStorage.name = res.data.data.loginUser.user.name
					console.log(sessionStorage.roleId);
					if (sessionStorage.roleId == 2) {
						this.$router.push("/index/console/statistics");
					} else {
						this.$router.push("/index/console/register");
					}
				})
					
			})
		}
	}
</script>

<style>
</style>
